import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5aca5b95"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "terminal-list-drawer" }
const _hoisted_2 = { class: "filter-row" }
const _hoisted_3 = { style: {"display":"flex"} }
const _hoisted_4 = { style: {"display":"flex"} }

import { ref, reactive, computed, watch } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import ExportDropdown from '@/views/dashboard/_components/export-dropdown/export-dropdown.vue'

import CmTable from '@/components/cmTable/index.vue'
import CmForm from '@/components/cmForm/index.vue'
import { SubnetStatusItem } from '../subnet-status/subnet-status.service'
import { UninstalledTerminalDrawerService } from './uninstalled-terminal-drawer.service'
import { FormActionType, FormSize, FormType, ObjectFormItem } from '@/components/cmForm/types'
import BtnIcon from '@/views/dashboard/_components/btn-icon/btn-icon.vue'
import { TerminalTypeOptions } from '@/views/dashboard/_enum/terminal-type'
import {  formatTimeStamp } from '@/utils/time'
import { calculateSubnetInfo } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'uninstalled-terminal-drawer',
  props: {
  modelValue: {
    type: Boolean,
    default: false
  },
  subnetData: {
    type: Object as () => SubnetStatusItem | null,
    default: null
  },
  hasPermission: {
    type: Boolean,
    default: true
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()
const props = __props

const hasPermission = computed(() => props.hasPermission)

const emit = __emit

const drawerVisible = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
})

const injector = useReflectiveInjector([UninstalledTerminalDrawerService])
const service = injector.get(UninstalledTerminalDrawerService)

const tableRef = ref<any>()
const { refreshList } = useCmTableListRefresh(tableRef)
const totalCount = computed(() => tableRef.value?.total || 0)

const drawerTitle = computed(() => {
  const subnetAddress = props.subnetData?.subnet_address || ''
  return subnetAddress ? t('uninstalledDrawer.title', { address: subnetAddress }) : t('uninstalledDrawer.titleShort')
})

const form = reactive({
  subnet_address: props.subnetData?.subnet_address || '',
  system_type: undefined as number | undefined,
  keyword: ''
})

const formColumns = reactive<ObjectFormItem<typeof form, 'system_type' | 'keyword'>>({
  system_type: {
    colOpt: { style: 'width: 150px;flex:0 0 auto' },
    hiddenAllLabel: true,
    type: FormType.Select,
    placeholder: t('discoveredList.osPlaceholder'),
    selectOpt: {
      clearable: true,
    },
    dictData: TerminalTypeOptions,
    events: {
      change: () => void refreshList(),
    }
  },
  keyword: {
    colOpt: { style: 'flex: 0 0 300px' },
    hiddenAllLabel: true,
    placeholder: t('discoveredList.searchPlaceholder'),
    modelModifiers: { trim: true },
    inputOpt: {
      'suffix-icon': 'el-icon-search',
    },
    events: {
      blur: () => void refreshList(),
      keypress: (e: any) => e.charCode === 13 && void refreshList()
    }
  }
})

const pageOption = {
  pageNumName: 'page',
  pageSizeName: 'limit'
}

const tableOpt = {
  columns: [
    { prop: 'ip_address', label: t('discoveredList.ipAddress'),minWidth:150, showOverflow:true, columnOpt: { sortable: true } },
    { prop: 'mac', label: t('discoveredList.macAddress'),minWidth:150, showOverflow:true},
    { prop: 'computer_name', label: t('discoveredList.computerName'),minWidth:150, showOverflow:true, formatter: (_row: any, value: string) => value || '--' },
    { prop: 'system_name', label: t('discoveredList.osVersion'),minWidth:150, showOverflow:true, formatter: (_row: any, value: string) => (String(value).toLocaleLowerCase() === 'unknown' || !value) ? '--' : value },
    { prop: 'hardware_info', label: t('discoveredList.vendorInfo'),minWidth:200, showOverflow:true, formatter: (_row: any, value: string) => (String(value).toLocaleLowerCase() === 'unknown' || !value) ? '--' : value },
    { prop: 'subnet_address', label: t('discoveredList.subnetSegment'),minWidth:150, showOverflow:true, },
    { prop: 'first_time', label: t('discoveredList.firstFoundTime'), minWidth:150,  formatter: (_row: any, value: number) => formatTimeStamp(value, 'YYYY-MM-DD HH:mm') },
    { prop: 'last_time', label: t('discoveredList.lastFoundTime'), minWidth:150, formatter: (_row: any, value: number) => formatTimeStamp(value, 'YYYY-MM-DD HH:mm') },
    { prop: 'remarks', label: t('subnetStatus.remarks'),showOverflow:true,  }
  ],
  bodyStyle: { padding: 0 },
  showActionBar: false,
  showSearch: false,
  showRightToolbar: true,
  height: '100%',
  path: 'list',
  totalPath: 'total'
}

function getListApi (params: any) {
   const info = calculateSubnetInfo(props.subnetData?.subnet_address || '')
  return service.getUninstalledTerminalList({
    subnet_address_start: props.subnetData?.subnet_address ? info.fullRangeStart:undefined,
    subnet_address_end: props.subnetData?.subnet_address ? info.fullRangeEnd:undefined,
    ...form,
    limit: params.limit,
    page: params.page,
    sort: 'ip',
    asc: params.asc !== undefined ? params.asc : true
  })
}

watch(() => drawerVisible.value, (visible) => {
  if (visible) {
    form.subnet_address = props.subnetData?.subnet_address || ''
    form.system_type = undefined
    form.keyword = ''
    void refreshList()
  }
})

function download (type: 0 | 1) {
 const info = calculateSubnetInfo(props.subnetData?.subnet_address || '')
  service.downloadUninstalledTerminalList(type, {
   subnet_address_start: props.subnetData?.subnet_address ? info.fullRangeStart:undefined,
   subnet_address_end: props.subnetData?.subnet_address ? info.fullRangeEnd:undefined,
    ...form,
    limit: 0,
    page: 0,
  }, t('uninstalledDrawer.exportFileName'))
}

return (_ctx: any,_cache: any) => {
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: drawerVisible.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((drawerVisible).value = $event)),
    title: drawerTitle.value,
    size: "80%",
    "append-to-body": "",
    "destroy-on-close": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(ExportDropdown, {
              "has-permission": hasPermission.value,
              onExport: download
            }, null, 8, ["has-permission"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(CmForm, {
              modelValue: form,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form) = $event)),
              rowOpt: { style: 'justify-content:flex-end' },
              formSize: _unref(FormSize).Small,
              formColumns: formColumns,
              formType: _unref(FormActionType).Other,
              "onUpdate:formType": _cache[1] || (_cache[1] = ($event: any) => ((_unref(FormActionType).Other) = $event))
            }, null, 8, ["modelValue", "formSize", "formColumns", "formType"])
          ])
        ]),
        _createVNode(CmTable, {
          ref_key: "tableRef",
          ref: tableRef,
          "has-permission": hasPermission.value,
          "table-opt": tableOpt,
          api: getListApi,
          "page-option": pageOption,
          modelValue: form,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form) = $event))
        }, null, 8, ["has-permission", "modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})